import { render, staticRenderFns } from "./DtBtn.vue?vue&type=template&id=c5ec3480&"
import script from "./DtBtn.vue?vue&type=script&lang=js&"
export * from "./DtBtn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports